














import { Vue, Component, Prop } from 'vue-property-decorator';

export interface Screen {
    title: string;
    icon: string;
    url: string;
}

@Component
export default class ScreenList extends Vue {
    @Prop() private screenList?: Screen[];

    // ページ遷移処理
    private goOtherPage(path: string) {
        this.$router.push({
            path,
        });
    }
}
